import React, {useState, useEffect} from "react"
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/system';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
// import Button from '@mui/material/Button';
import { getSoftDeletedNotes, restoreSoftDeletedNotes } from "../../../services/api/apiHandler";
import swal from "sweetalert";
import { socket } from "../../../services/socket/socket";
import { fetchTTBSData } from "../../../redux/actions/TemplateTabs/actionBS";
import { useDispatch } from "react-redux";
import {ReactComponent as RestoreIcon} from "../../../myfin_v2/assets/icons/restore.svg";

// import { ReactComponent as DeleteIcon} from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as RecycleBinIcon } from "../../../myfin_v2/assets/icons/recycleBin.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import modalcss from "../../../../src/myfin_v2/css/modal.module.css"; 
import { Button } from "../../../myfin_v2/elements/Button";
import { motion } from "framer-motion";
import tablecss from "../../../myfin_v2/css/table.module.css";
import { ReactComponent as NoDataIcon } from "../../../myfin_v2/assets/icons/noData.svg";

const RestoreSoftDelete = (props) => {
    const user = JSON.parse(localStorage.getItem('user'));
     const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [deletedNotes, setDeletedNotes] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const project_id = localStorage.getItem("project_id");
    const tb_id = localStorage.getItem("tb_id");

    const handleToggleSelectAll = () => {
        if (selectedRows.length < deletedNotes.length) {
          // If no rows are selected, select all rows
          setSelectedRows([...deletedNotes]);
        } else {
          // If some rows are selected, unselect all rows
          setSelectedRows([]);
        }
      };
    
      const handleRowCheckboxChange = (row) => {
        if (selectedRows.find((item)=>item.notes_no === row.notes_no)) {
          // If row is already selected, remove it from selectedRows
          setSelectedRows(selectedRows.filter((item) => item.notes_no !== row.notes_no));
        } else {
          // If row is not selected, add it to selectedRows
          setSelectedRows([...selectedRows, row]);
        }
      };

    useEffect(()=> {
        fetchSoftDeletedData();
    }, [])

    const fetchSoftDeletedData = () => {
        getSoftDeletedNotes(project_id).then((response)=> {
            if(typeof response.data.result !== 'string'){
                setDeletedNotes(response.data.result);
            }
        }).catch((err)=> {
            swal("Error!", err.message, "danger", {
                button: "OK",
            });
        })
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
         setSelectedRows([]);
        setOpen(false);
    };

    const handleRestore = () => {
        if(user.responsibilities === "view"||user.responsibilities === "approver"){
            swal("Warning","You dont have access to restore it","warning");
        }
        // Handle restore action here
        if(selectedRows.length === 0){
            return swal("Warning!","select at-least one row for note restore.", "warning", {
                button: "OK",
            });
        }

        swal({
            title: "Are you sure to restore the notes?",
            text: "you can again delete this note!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                const payload = {
                    selectedNotes: selectedRows
                }
                restoreSoftDeletedNotes(project_id, payload).then(()=> {
                    dispatch(fetchTTBSData(project_id, tb_id))
                    setSelectedRows([]);
                    fetchSoftDeletedData();
                    setTimeout(()=>{
                        socket.emit("request-mapped-grouping", {project_id, tb_id});
                        socket.emit("request-balance-sheet", {project_id, tb_id})
                        socket.emit("request-pnl-statement", {project_id, tb_id});
                        socket.emit("request-fetch-console-notes", { pid: project_id });
                        
                        handleClose();
                    }, [2000])
                    swal("Poof! Selected Notes has been restored!", {
                        icon: "success",
                    });
                }).catch((err)=> {
                    swal("Error!", err.message, "error", {
                        button: "OK",
                    });
                })
            }
          });
        
      };
    
      const handleCancel = () => {
        // Handle cancel action here
        setSelectedRows([]);
        handleClose();
      };

    return (
        <div>
            <Tooltip title="Notes Soft Delete">
                {/* <IconButton onClick={handleOpen}>
                    <RestoreFromTrashIcon/>
                </IconButton> */}
                 <RecycleBinIcon onClick={handleOpen}>
                    <RestoreFromTrashIcon/>
                </RecycleBinIcon>
            </Tooltip>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                {/* <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 800, // Adjust the width of the modal
                height: 600,
                bgcolor: 'white', // Set background color to white
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                }}> */}
                 <div
       className={modalcss.modal_backdrop}>
      <motion.div
        initial={{ y: 500, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 0, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className={`${modalcss.modal}`}
        style={{
        //   ...(width ? { width: width } : {}),
        //   ...(height ? { height: height } : {}),
        //   ...(minHeight ? { minHeight: minHeight } : {}),
          width: "40%",
        }}
      >
                {/* <h2 id="modal-modal-title">Restore Deleted Notes</h2> */}
                   <div
          className={`${
            // headerBottomLine
            //   ?
             modalcss.modal_header
            //   :
            //    modalcss.modal_header_without_bottomline
          }`}
        >
                <h2 className={modalcss.modal_title}> Restore Deleted Notes</h2>
                 <div className={modalcss.modal_header_actions}>  <CloseIcon
                           onClick={handleClose}
                           className="clickable"
                         /></div>
          </div>
                {/* <p id="modal-modal-description">Please select the rows and restore those notes.</p> */}
                <div style={{maxHeight: "500px", overflowY: 'auto', paddingLeft: "10px"}}>
                 <style>
                    {`
                    input[type="checkbox"] {

                        appearance: none;    
                        
                        position: relative;
                        // margin-top: 10px;
                        vertical-align: middle;
                        }
                        input[type="checkbox"]:checked {
                        
                        background-color: #277154;
                        }


                        input[type="checkbox"]:checked::after {
                        content: "✔";
                        color: white;
                        position: absolute;
                        // top: 0px;
                        // left: 2px;
                         top: 55%;
                         left: 50%;
                        transform: translate(-50%, -50%);
                        font-size: 11px;
                        }`}
                 </style>
                    {deletedNotes.length > 0 ? (
                    <Table  className={`${tablecss.customTable} ${tablecss.stickyTable} thead th`}>
                        <TableHead>
                        <TableRow >
                            <TableCell>
                            <input
                            type="checkbox"
                             style={{
                                            // appearance: "none",
                                            border: "1px solid #7ECEA7",
                                            borderRadius: "4px"
                                        }}
                            checked={selectedRows.length > 0 && selectedRows.length === deletedNotes.length}
                            onChange={handleToggleSelectAll}
                            />
                            </TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>FS Group</TableCell>
                            <TableCell>Notes Group</TableCell>
                            {/* <TableCell> </TableCell> */}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            {deletedNotes.map((note, key)=> (
                                <TableRow key={key}>
                                    <TableCell>
                                        <input
                                        type="checkbox"
                                        // style={{borderColor: "green", width: "45px"}}
                                        style={{
                                            appearance: "none",
                                            border: "1px solid #7ECEA7",
                                            borderRadius: "4px",

                                          
                                        }}
                                        disabled={user.responsibilities === "view"||user.responsibilities === "approver"}
                                        checked={selectedRows.find((item)=>item.notes_no === note.notes_no)}
                                        onChange={() => handleRowCheckboxChange(note)}
                                        />
                                    </TableCell>
                                    <TableCell>{note.type}</TableCell>
                                    <TableCell>{note.group}</TableCell>
                                    <TableCell>{note.notes_grp}</TableCell>
                                    {/* <TableCell> <RestoreIcon onClick={() => handleRestore(note.notes_no)}/></TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                     ) : (
                              <>
                                <div className={`${commoncss.dFlexClm} mt-5`} style={{"align-items":"center"}}>
                                  <NoDataIcon />
                                  <span className={`${commoncss.greyLabel} mt-2`}>There are no deleted items</span>
                                </div>
                              </> 
                            )}
                    
                </div>
                    {/* <Box sx={{ mt: 2, textAlign: 'center' }}>
                        <button className="custom-common-theme-bg-color px-2 py-1 text-white custom-font-600 radius-6px primary-border" onClick={handleRestore} disabled={user.responsibilities === "approver" || user.responsibilities === "view"}>
                        Restore
                        </button>
                        <button className="bg-danger px-2 py-1 text-white custom-font-600 radius-6px ml-2 border-danger" onClick={handleCancel}>
                        Cancel
                        </button>

                    </Box> */}
                     <div className={modalcss.modal_footer}>
                        <>
                         <Button
                                    btnColor={buttoncss.secondary}
                                    onClick={handleClose}
                                    label="Cancel"
                                  />
                                  {
                                    // selectedRows && 
                                    selectedRows?.length > 0 ? (
                                      <span><span className={`${commoncss.primaryLabel1} ${commoncss.fs15} ${commoncss.fw600} mr-3`}>({selectedRows?.length}) Selected</span>
                                        <Button
                                          btnColor={buttoncss.primary}
                                          label={"Restore Selected"}
                                        //   onClick={() => RestoreSelected()}
                                         onClick={handleRestore} disabled={user.responsibilities === "approver" || user.responsibilities === "view"}
                                        />
                                      </span>
                                    ) :
                                      <Button
                                        btnColor={buttoncss.primary}
                                        label={"Restore Selected"}
                                        class_={buttoncss.disabledBtn}
                                      />
                                  }
                                  {/* {rows.length > 0 ?(<></>): ( */}
                                   {/* {deletedNotes.length > 0 ? (<></>) : (
                                  <Button
                                    btnColor={buttoncss.primary}
                                    onClick={handleClose}
                                    label="Proceed"
                                  />)} */}
                                  
                        </>
                     </div>
                </motion.div>
                </div>
            </Modal>
        </div>
    )
}


export default RestoreSoftDelete;